import { FC } from 'react';
import ConversationTile from './conversation-tile';
import PublicServiceTile from './public-service-tile';
import AgentTile from './agent-tile';
import { TileModel, TileType } from '@/lib/models/user-settings/tile.model';

export interface BaseTileProps {
  tile: TileModel;
  sortable?: boolean;
  showAccessIcon?: boolean;
  showInfo?: boolean;
  description?: string;
  dotdot?: boolean;
}

export const TILE_COMPONENTS: Record<TileType, FC<BaseTileProps> | undefined> = {
  conversation: ConversationTile,
  'public-service': PublicServiceTile,
  agent: AgentTile,
  none: undefined,
  surepath: undefined,
};
